"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchToObject = function (search) {
    return search.substring(1).split("&").reduce(function (result, value) {
        var parts = value.split('=');
        if (parts[0])
            result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
        return result;
    }, {});
};
exports.makeCancelable = function (promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise
            .then(function (val) {
            return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
        })
            .catch(function (error) {
            return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
        });
    });
    wrappedPromise.cancel = wrappedPromise.cancel || function () {
        hasCanceled_ = true;
    };
    return wrappedPromise;
};
exports.mapObjectKeys = function (mapper, obj) {
    var mapperKeys = Object.keys(mapper);
    return Object.keys(obj).reduce(function (newObj, property) {
        var _a;
        var mapperIndexKey = mapperKeys.indexOf(property);
        if (mapperIndexKey
            > -1) {
            newObj = __assign({}, newObj, (_a = {}, _a[mapper[mapperKeys[mapperIndexKey]]] = obj[property], _a));
        }
        else {
            newObj[property] = obj[property];
        }
        return newObj;
    }, {});
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../@core/dist/utils.js
// module id = 127
// module chunks = 0